class VideoCarousel {
  constructor(selector = ".my-carousel__swiper") {
    this.selector = selector;

    this.effectStrength = {
      verticalShiftFactor: 0.05,
      rotationFactor: 0.5,
    };

    this.init();
  }

  init() {
    this.swiperEl = document.querySelector(this.selector);

    if (!this.swiperEl) return;

    this.initSwiper();

    this.waitForSwiper(() => {
      this.animateCarousel();
    });
  }

  initSwiper() {
    if (this.swiperEl.swiper) return;

    this.swiper = new Swiper(this.swiperEl, {
      slidesPerView: 4,
      spaceBetween: 16,
      grabCursor: true,
      setWrapperSize: true,
  virtualTranslate: false,
      maxBackfaceHiddenSlides: 0,
      breakpoints: {
        1: {
          slidesPerView: 2,
          spaceBetween: 36,
        },
        400: {
          slidesPerView: 2,
          spaceBetween: 36,
        },
        500: {
          slidesPerView: 2,
          spaceBetween: 50,
        },
        650: {
          slidesPerView: 2,
          spaceBetween: 60,
        },
        768: {
          loop: true,
          slidesPerView: 3,
          spaceBetween: 50,
        },
        850: {
          spaceBetween: 60,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 70,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 70,
        },
      },
    });
  }

  waitForSwiper(callback) {
    const check = () => {
      if (
        this.swiperEl &&
        this.swiperEl.classList.contains("swiper-initialized")
      ) {
        console.log("Swiper Loaded");
        callback();
      } else {
        requestAnimationFrame(check);
      }
    };

    check();
  }

  updateSlideTransforms() {
    const slides = document.querySelectorAll(".single");

    slides.forEach((slide) => {
      const rect = slide.getBoundingClientRect();

      const distanceFromCenter =
        window.innerWidth / 2 - (rect.left + rect.width / 2);

      const maxDistance = window.innerWidth / 2;

      const normalized = distanceFromCenter / maxDistance;

      let maxRotation;

      if (window.innerWidth < 768) {
        maxRotation = 5;
      } else if (window.innerWidth < 1024) {
        maxRotation = 7.9;
      } else {
        maxRotation = 7.9;
      }

      const rotation = -normalized * maxRotation;

      let verticalOffset =
        Math.abs(distanceFromCenter) *
          this.effectStrength.verticalShiftFactor -
        rect.width * this.effectStrength.verticalShiftFactor;

      if (verticalOffset < 0) verticalOffset = 0;

      slide.style.transform = `
        translateY(${verticalOffset}px)
        rotate(${rotation}deg)
        translatez(0)
      `;

      slide.style.transformOrigin =
        distanceFromCenter < 0 ? "left top" : "right top";
    });
  }

  animateCarousel() {
    const animate = () => {
      this.updateSlideTransforms();
      requestAnimationFrame(animate);
    };

    animate();
  }
}

new VideoCarousel();
window.videoCarousel = new VideoCarousel();